import { ModelBase } from '@singularsystems/neo-core';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../DomainTypes';

class CachedState extends ModelBase {

    constructor() {
        super();
        this.makeObservable();
    }

    public accrualsCreated = false;

    public filesTransferred = false;
}

export default class SystemMaintenanceVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private apiClient = AppService.get(Types.Domain.ApiClients.SystemMaintenance)) {

        super(taskRunner);
        this.makeObservable();

        if (!SystemMaintenanceVM.cachedState) {
            SystemMaintenanceVM.cachedState = new CachedState();
        }
    }

    public async initialise() {

    }

    public static cachedState: CachedState;

    public async createAccruals(force: boolean) {
        SystemMaintenanceVM.cachedState.accrualsCreated = true;

        await this.taskRunner.run(() => this.apiClient.createAccruals(force));
    }

    public async extendAccruals() {
        SystemMaintenanceVM.cachedState.accrualsCreated = true;

        await this.taskRunner.run(() => this.apiClient.extendAccruals());
    }

    public tempFileCount: number | null = null;

    public async getTempFileCount() {
        this.tempFileCount = await this.taskRunner.waitForData(this.apiClient.getTempFileCount());
    }

    public async transferFiles() {
        SystemMaintenanceVM.cachedState.filesTransferred = true;

        await this.taskRunner.run(() => this.apiClient.transferFiles());
    }
}